export default __webpack_public_path__ + "static/media/ADOBE_GARAMOND_LT_BOLD.1c2c68fb.ttf";